import React from 'react'; 
import '../styles/SkillsSection.scss'; 

//I should probably look into getting some kind of visuals for this section.
//Maybe throw up a picture of me, and pictures of the girls. 

const SkillsSection = () => {

    const AboutMeTitle = "My Toolkit.";
    const AboutMeSkills = [
        {
            type: "Languages",
            skills: ["HTML", "CSS", "Javascript", "Classic ASP", "VB Script", "PHP"]
        },
        {
            type: "Software",
            skills: ["Figma", "Adobe Products", "Microsoft Office", "Postman", "HubSpot", "Ceros", "Markup"]
        },
        {
            type: "Web Technologies",
            skills: ["JQuery", "SASS", "Webpack", "AngularJS", "ReactJS", "Bootstrap", "Grunt", "Gulp", "Mustache", "Jest", "Storybook"]
        },
        {
            type: "Database",
            skills: ["Microsoft SQL Server"]
        },
        {
            type: "Version Control",
            skills: ["GIT", "SVN", "TFS"]
        },
        {
            type: "Content Management Systems",
            skills: ["Wordpress", "Craft", "Sitefinity", "Contember", "Webflow", "Bubble"]
        },
        {
            type: "Content Delivery Networks",
            skills: ["Fastly"]
        },
        {
            type: "ECommerce",
            skills: ["WooCommerce", "Custom Solutions"]
        },
        {
            type: "SEO",
            skills: ["GA4", "GTM", "Google Search Console", "Ahrefs", "MOZ"]
        },
        {
            type: "Hosting/DNS Services",
            skills: ["Digital Ocean", "Pantheon", "Webair", "GoDaddy", "Network Solutions", "Vercel", "WPEngine"]
        },
        {
            type: "Development Enviroments",
            skills: ["Agile", "Test Driven Development"]
        },

    ];

    const SkillsOutput = AboutMeSkills.map((SkillGroup, i, arr) => 
        <ul key={i} className="skill-group">
            <li className="skill-group-grouping">
                <p className="skill-group-title">{SkillGroup.type}</p>
                <ul className="skill-group-skill-list">
                    {SkillGroup.skills.map((skill, j, arr) => 
                        <li key={j}><p className="skill-group-skill">{skill}</p></li>
                    )}
                </ul>
            </li>
        </ul>
    );

    return (
        <div id="skills" className="skills-section-section">
            <div className="skills-section-container">
                <h2 className="skills-section-header">{AboutMeTitle}</h2>
                <div className="skills-section-skills-container">
                    <h3 className="skills-section-skills-title">SKILLS</h3>
                    <div className="skills-section-skills-list-container">
                        {SkillsOutput}
                    </div>
                </div>
            </div>

        </div>
    )

}

export default SkillsSection; 
